/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-10 23:42:54
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 10:41:48
 * @FilePath: /wemeet-web-activity/src/pages/tickets/components/protocal/index.tsx
 * @Description: 同意协议
 */
import React, { memo, useContext } from 'react';
import { Checkbox, CheckboxGroup, Text } from '@tencent/tea-component';
import Link from '@tencent/tpm-meeting-active/esm/Link';
import { ThemeContext } from "../../context";
// import dataReport from '@utils/data-report';
import "./index.scss";
import { isMobile } from '@tencent/web-base';
const PARTICIPANTS_PROTOCOL_LINK = '/activity-participants-service-agreement.html';
const Protocal = ({
  setCheckProtol,
  checkProtol,
  link = PARTICIPANTS_PROTOCOL_LINK,
  text = '《腾讯会议参会者服务协议》',
  style = isMobile() ? {
    marginTop: 12,
    marginBottom: 0
  } : {
    marginTop: 12,
    marginBottom: 0,
    paddingLeft: 50
  },
  classNames,
  textStyle = {
    fontSize: 12
  }
}) => {
  const {
    dataReport
  } = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(CheckboxGroup, {
    className: classNames,
    style: style
  }, /*#__PURE__*/React.createElement(Checkbox, {
    onChange: val => {
      setCheckProtol(val);
      dataReport('e#event_order_confirm#agreement_button#click');
    },
    value: checkProtol
  }, /*#__PURE__*/React.createElement(Text, {
    style: textStyle,
    theme: "weak"
  }, "\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F", /*#__PURE__*/React.createElement(Link, {
    target: "_blank",
    href: link
  }, text))));
};
export default /*#__PURE__*/memo(Protocal);